// extracted by mini-css-extract-plugin
export default {"root":"sVOgk","left":"_2cIh0","right":"CGgM4","author":"VY0V1","actions":"_21sf3"};